module.exports = __webpack_public_path__ + "public/images/plus.10dc043f1bb1fe85c2a21719e7851946.svg";